import { Typography } from '@mui/material'
import styled from 'styled-components'

const EllipsisTypographyStyle = styled(Typography)`
  overflow-x: hidden;
  text-overflow: ellipsis;
`

export default EllipsisTypographyStyle
